import type { InventoryIdQueryParams } from "../InventoryIdQueryParams"
import type { ApiRoute, NoBody, NoPathParams } from "../api"
import type { DetailsEquipmentView } from "./details/DetailsEquipmentStageView"

export const resetToFactoryEquipmentIncludingWheelsRoute: ApiRoute<
	NoPathParams,
	InventoryIdQueryParams,
	NoBody,
	DetailsEquipmentView
> = {
	buildUrl: () => "/equipment/_reset_including_wheels",
	method: "post",
	path: "/equipment/_reset_including_wheels",
}
